import React from 'react';
import PropTypes from 'prop-types';

const LogChangesButton = ({ title, oldData, newData, type, onClick }) => (  
  <div
    className="QFLog_bot_key QFLog_bot_key_button"
    onClick={() => onClick(type, oldData, newData)}
    aria-hidden
  >
    <i className="fa fa-list" /> {title}
  </div>
);

LogChangesButton.propTypes = {
  title: PropTypes.string.isRequired,
  oldData: PropTypes.any,
  newData: PropTypes.any, 
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default LogChangesButton;